<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->
<header class="slds-page-header">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title" style="min-width: 10rem;">
      <div class="slds-media">
        <div class="slds-media__figure">
          <span class="slds-avatar slds-avatar_medium">
            <img alt="Track 4d Timesheet" src="/assets/accorto/expenseSheet-100.svg">
          </span>
        </div>
        <div class="slds-media__body">
          <h1>
            <span class="slds-page-header__title slds-truncate" i18n id="ext-hdr">Expenses</span>
            <span i18n>Not submitted</span>
          </h1>
        </div>
      </div>
    </div>

    <div class="slds-page-header__col-actionsX">
      <div class="slds-page-header__controls">
        <div class="slds-page-header__control">
          <ul *ngIf="queryFM"
              class="slds-grid slds-gutters_x-small slds-wrap">
            <li class="slds-col slds-size_1-of-1 slds-medium-size_3-of-8">
              <acc-form-date [ff]="fromFF" [fm]="queryFM" theId="fromDate"></acc-form-date>
            </li>
            <li class="slds-col slds-size_1-of-1 slds-medium-size_3-of-8">
              <acc-form-date [ff]="toFF" [fm]="queryFM" theId="toDate"></acc-form-date>
            </li>
            <li class="slds-col slds-size_1-of-1 slds-medium-size_2-of-8"
                style="line-height: 5rem;">
              <button (click)="doQuery()"
                      class="slds-button slds-button--neutral"
                      id="ext-query"
                      title="Query Expenses">
                <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#search"></use>
                </svg>
                <span i18n>Query</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>

  <!-- status -->
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-meta">
      <acc-status-line [error]="error" [message]="message"></acc-status-line>
    </div>
  </div>
</header>

<div class="slds-m-top_small slds-is-relative">
  <acc-data-table (saveRecords)="doSaveRecords($event)"
                  [records]="records"
                  [ui]="ui">
  </acc-data-table>
  <acc-spinner *ngIf="busy"></acc-spinner>
</div>
